import type {
  FoodRank,
  GetFoodRankResponse,
} from '@viome/viome-base/src/usecase/Nutrition/Nutrition.model';

export type FoodRankMap = Record<number, FoodRank>;

export const getFoodRankMap = (response?: GetFoodRankResponse) => {
  if (!response) return;

  const rankMap = response.reduce((acc, rank) => {
    acc[rank.id] = rank;

    return acc;
  }, {} as FoodRankMap);

  return rankMap;
};
